import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Circle, X, UploadCloud, FileText, BookOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;
const HIDE_KEY = "anatradex-checklist-hidden";
const GUIDE_KEY = "anatradex-guide-visited";

export const TesterChecklist = () => {
  const { user } = useAuth();
  const [progress, setProgress] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(HIDE_KEY) === "1");
  const guideVisited = localStorage.getItem(GUIDE_KEY) === "1";

  useEffect(() => {
    if (!user || hidden) return;
    const token = localStorage.getItem("auth_token");
    if (!token) return;
    axios.get(`${API}/api/users/progress`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setProgress(r.data))
      .catch(() => setProgress(null));
  }, [user, hidden]);

  if (!user || hidden || !progress) return null;

  const steps = [
    { done: progress.imported_trades > 0, icon: UploadCloud, label: "Importer vos trades réels", sub: progress.imported_trades > 0 ? `${progress.imported_trades} trades importés` : "CSV MT4 / MT5 / cTrader", to: "/app/import", testid: "checklist-step-import" },
    { done: progress.reports_generated > 0, icon: FileText, label: "Générer votre rapport statistique", sub: progress.reports_generated > 0 ? `${progress.reports_generated} rapport(s) généré(s)` : "PBO, Deflated Sharpe, permutations", to: "/app/import", testid: "checklist-step-report" },
    { done: guideVisited, icon: BookOpen, label: "Lire le guide d'interprétation", sub: guideVisited ? "Guide consulté" : "Comprendre PBO, DSR et p-values", to: "/app/guide", testid: "checklist-step-guide" },
  ];
  const doneCount = steps.filter((s) => s.done).length;
  if (doneCount === steps.length) return null;

  const dismiss = () => { localStorage.setItem(HIDE_KEY, "1"); setHidden(true); };

  return (
    <div className="panel p-4 border border-accent-blue/25 relative" data-testid="tester-checklist">
      <button onClick={dismiss} className="absolute top-3 right-3 text-white/30 hover:text-white" data-testid="checklist-dismiss-btn" aria-label="Masquer">
        <X size={14} />
      </button>
      <div className="flex items-center gap-2 mb-3">
        <div className="text-sm font-semibold">Vos premiers pas sur ANATRADEX</div>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-blue/15 border border-accent-blue/30 text-accent-blue font-mono" data-testid="checklist-progress-badge">
          {doneCount}/{steps.length}
        </span>
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        {steps.map((s) => (
          <Link key={s.testid} to={s.to} data-testid={s.testid}
                className={`flex items-start gap-2.5 rounded-lg border p-3 transition ${s.done ? "border-up/30 bg-up/5" : "border-white/10 bg-white/5 hover:border-accent-blue/40"}`}>
            {s.done
              ? <CheckCircle2 size={16} className="text-up shrink-0 mt-0.5" />
              : <Circle size={16} className="text-white/30 shrink-0 mt-0.5" />}
            <div>
              <div className={`text-xs font-semibold ${s.done ? "text-up" : "text-white"}`}>{s.label}</div>
              <div className="text-[10px] text-white/45 mt-0.5">{s.sub}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
